// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RadioGroup__container-a50e2b {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 16px;
  border: none;
}

.RadioGroup__title-f53634 {
  font: var(--font-body-1);
  letter-spacing: var(--font-spacing-body-1);
  color: var(--base-110);
}`, "",{"version":3,"sources":["webpack://./../../packages/components/src/form/RadioGroup/RadioGroup.styles.m.css"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;EACA,sBAAA;AACF","sourcesContent":[".container {\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  margin-top: 16px;\n  border: none;\n}\n\n.title {\n  font: var(--font-body-1);\n  letter-spacing: var(--font-spacing-body-1);\n  color: var(--base-110);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `RadioGroup__container-a50e2b`,
	"title": `RadioGroup__title-f53634`
};
module.exports = ___CSS_LOADER_EXPORT___;
